import { useRef, useState } from 'react'

import styled from 'styled-components/macro'

import {
  AppsRounded,
  CloseRounded,
  CodeRounded,
  GroupsRounded,
  HelpCenterRounded,
  LogoutRounded,
  PersonOutlineRounded,
} from '@mui/icons-material'
import { useAppDispatch } from 'app/hooks'
import { useLocation, useNavigate } from 'react-router-dom'
import { asyncSignOut } from 'services/authSlice'
import { baseApi } from 'services/baseApi'
import { useGetUserQuery } from 'services/userApi'
import { useClickOutside } from 'utils/useClickOutside'
import { useKey } from 'utils/useKey'

export const AccountMenu = ({}: {}) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const { data: user, isLoading: userLoading } = useGetUserQuery()

  const [menuOpen, setMenuOpen] = useState(false)

  const wrapperRef = useRef<HTMLDivElement | null>(null)

  useClickOutside(wrapperRef, () => setMenuOpen(false))

  useKey('Escape', () => setMenuOpen(false))

  const withCloseAndNavigate = (href) => (event) => {
    event.stopPropagation()
    setMenuOpen(false)
    if (pathname !== href) {
      navigate(href)
    }
  }

  return (
    <MenuOpenButton onClick={() => setMenuOpen(true)}>
      <p style={{ fontWeight: 600, color: '#fff' }}>{user?.firstName?.[0] + user?.lastName?.[0] || ''}</p>

      <MenuCloseButton
        menuOpen={menuOpen}
        onClick={(event) => {
          event.stopPropagation()
          setMenuOpen(false)
        }}
      >
        {menuOpen && <CloseRounded sx={{ color: '#fff' }} />}
      </MenuCloseButton>

      {menuOpen && (
        <>
          <MenuPopover ref={wrapperRef}>
            <MenuGrid>
              <MenuItem onClick={withCloseAndNavigate('/dashboard/workspaces')}>
                <AppsRounded />
                <MenuLabel>Workspaces</MenuLabel>
              </MenuItem>

              <MenuItem onClick={withCloseAndNavigate('/dashboard/account')}>
                <PersonOutlineRounded />
                <MenuLabel>Account & Billing</MenuLabel>
              </MenuItem>

              <MenuItem onClick={withCloseAndNavigate('/dashboard/integrations')}>
                <CodeRounded />
                <MenuLabel>Integrations</MenuLabel>
              </MenuItem>

              <MenuItem
                // onClick={withCloseAndNavigate('/dashboard/users')}
                onClick={() => alert('Coming soon!')}
              >
                <GroupsRounded />
                <MenuLabel>Users</MenuLabel>
              </MenuItem>

              {/* <MenuItem onClick={withCloseAndNavigate('/dashboard/developers')}>
                <CodeRounded />
                <MenuLabel>Developers</MenuLabel>
              </MenuItem> */}

              <MenuItem onClick={withCloseAndNavigate('/dashboard/support')}>
                <HelpCenterRounded />
                <MenuLabel>Support</MenuLabel>
              </MenuItem>

              <MenuItem
                onClick={() => {
                  dispatch(baseApi.util.resetApiState())
                  dispatch(asyncSignOut())
                }}
              >
                <LogoutRounded
                  sx={{
                    // color: '#a44848'
                    color: 'white',
                  }}
                />
                <MenuLabel
                  style={{
                    // color: '#a44848'
                    color: 'white',
                  }}
                >
                  Sign out
                </MenuLabel>
              </MenuItem>
            </MenuGrid>
          </MenuPopover>
        </>
      )}
    </MenuOpenButton>
  )
}

const MenuOpenButton = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 30px;
  min-width: 30px;
  height: 30px;
  border-radius: 15px;
  background: linear-gradient(45deg, #11d2db, #332774);
  cursor: pointer;
  user-select: none;
  border: solid 1px #333333;
  box-sizing: border-box;
`

const MenuCloseButton = styled.div<{ menuOpen: boolean }>`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #bbe0f3;
  width: 100%;
  height: 100%;
  transition: 200ms opacity ease;
  border-radius: inherit;
  cursor: pointer;

  width: ${({ menuOpen }) => (menuOpen ? '100%' : 0)};
  height: ${({ menuOpen }) => (menuOpen ? '100%' : 0)};
  opacity: ${({ menuOpen }) => (menuOpen ? 1 : 0)};
`

const MenuPopover = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  top: 40px;
  right: 0;
  /* width: 340px; */
  width: 240px;
  /* height: 200px; */
  background: #fafafa;
  z-index: 200;
  border-radius: 4px;
  padding: 10px;
  box-sizing: border-box;
  /* box-shadow: 0px 2px 10px 1px rgba(0, 0, 0, 0.4); */
  box-shadow: rgb(0 0 0 / 8%) 0px -2px 4px, rgb(0 0 0 / 6%) 0px 2px 12px, rgb(0 0 0 / 4%) 0px 8px 14px,
    rgb(0 0 0 / 2%) 0px 12px 16px;

  /* background: linear-gradient(45deg, rgba(13, 131, 217, 1), rgba(17, 210, 219, 1)); */
  background: linear-gradient(45deg, #4838a4, #0c98ff 150%);
  color: white;
  cursor: default;
`

const MenuTitle = styled.p`
  font-size: 14px;
  margin: 20px auto;
  color: white;
`

const MenuGrid = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  padding: 0;
`

const MenuItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 80px;
  border-radius: 0;
  transition: 200ms all ease;
  margin: 10px;
  cursor: pointer;

  &:hover {
    background: #fff3;
    border-radius: 20px;
  }
`

const MenuLabel = styled.p`
  margin-top: 4px;
  color: #fff;
  font-size: 12px;
  text-align: center;
`
